//LATE -
//NEW 2026-03-26

/**
 * NOTES: 
 * //input tags in Portals should pass in autoFocusRef to maintain focus on value change.
 * <Input autoFocusRef={inputFocusRef}/>
 */

import { ReactNode } from "react";
import { createPortal } from "react-dom";

interface Props {
    children: ReactNode
}

const Portal = ({ children }: Props) => {
    return createPortal(children, document.body);
};
export default Portal;